<template>
    <div class="uk-container">
        <!-- pure upload that scott made :) -->
        <div class="upload" id="uploadbox">
            <input class="upload-input" id="upload-input" type="file" @change="onFileChange" accept="image/*" multiple/>
            <div id="filedrag" @dragover="FileDragHover" @dragleave="FileDragHover" @drop="onFileChange">
                <div class="uk-text-center" style="pointer-events: none; font-size: 18px;">
                    <span uk-icon="icon: cloud-upload"></span>
                    <span class="uk-text-middle"> Import one or more images, or </span>
                    <a style="pointer-events: auto"><label class="uk-link uk-text-bottom" for="upload-input">click here</label></a>
                </div>
            </div>
        </div>
          <!-- User Modal for selecting resize value if uploads are too big -->
          <div id="modal-resize-select" uk-modal>
            <div class="uk-modal-dialog uk-modal-body uk-padding-small uk-margin-auto-vertical">
              <button class="uk-modal-close-default" type="button" uk-close></button>
                <div class="uk-modal-header">
                    <h4 class="uk-modal-title uk-text-default uk-text-center">Resize Photos <i class="material-icons" style="font-size: 36px; vertical-align: middle; color: #11bb77">photo_size_select_large</i></h4>
                </div>
                <div class="resize-modal-body uk-margin">
                    <div>&middot; Total size: <b>{{totalUploadSize}}mb</b>. <br> 
                         &middot; Please choose a max width/length to resize.</div>
                    <div class="uk-margin">
                        <label class="uk-form-label" for="form-stacked-text">Select Size (longest side):</label>
                        <select v-model="maxXY" class="uk-select">
                            <option value="400">400px - Mobile</option>
                            <option value="800">800px - Web</option>
                            <option value="1280">1280px - Desktop</option>
                            <option value="1920">1920px - Very Large <span class="uk-text-small"><i>(slower)</i></span></option>
                        </select>
                    </div>
                    <div class="uk-margin">
                        <ul uk-accordion>
                            <li>
                                <a id="somethingelse" class="uk-accordion-title resize-accordian-title" href="#">Advanced</a>
                                <div class="uk-accordion-content">
                                    <div class="uk-form-controls uk-form-width-small uk-margin">
                                        <label class="uk-form-label" for="form-horizontal-text-maxxy">Custom Size (px):</label>
                                        <input v-model="maxXY" class="uk-input" id="form-horizontal-text-maxxy" type="text" placeholder="...px">
                                    </div>                                
                                    <div style="margin-bottom: 20px;">
                                        <label class="uk-form-label">Export Quality:</label>
                                        <div class="uk-flex">
                                            <div class="uk-width-2-3 uk-margin-auto-vertical">
                                                <vue-slider ref="vueSlider" v-model="imageQuality" :tooltip="'none'"></vue-slider>
                                            </div>
                                            <div class="uk-width-1-3 uk-margin-left">
                                                <input class="uk-input uk-form-width-xsmall uk-form-small" type="text" v-model="imageQuality"><span>%</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <p class="uk-text-small uk-text-muted">Total upload size can not exceed <b>{{totalSizeBeforeCompression}}mb.</b></p>
                </div>
                <div class="uk-modal-footer uk-modal-footer-edit uk-text-right"> 
                    <button @click="userRejectedResize()" class="uk-button uk-button-default uk-modal-close" type="button">Cancel</button> 
                    <button @click="userAcceptedResize()" class="uk-button uk-button-primary uk-margin-small-left">Ok</button> 
                </div>              
            </div>
          </div>        
    </div>
</template>

<script>
    import UIkit from 'uikit'
    import Vue from 'vue'    
    // import worker from 'workerize-loader!../../assets/js/jimp-worker.js'
    import {fit} from '../../assets/js/fitters/fit.js'
    import {fitTiled} from '../../assets/js/fitters/fitTiled.js'
    import {resizeImage} from '../../assets/js/fitters/resizeImage.js'
    require('jimp/browser/lib/jimp');
    const Jimp = window.Jimp;
    const base64_arraybuffer = require('base64-arraybuffer/lib/base64-arraybuffer.js');
    // const EXIF = require('exif-js')    
    require('webworkify')

    export default {
        name: 'upload-handler',    
        data() {
            return {
                arrayBuffer: [],
                compressOnImport: false,
                totalSizeBeforeCompression: 18, //mb
                totalLength: 0,
                totalUploadSize: 0,
                workingFileList: [], 
                FileList: null, 
                maxXY: 1280,
                imageQuality: 100
            }
        },
        methods: {
            onFileChange: function(e) {
                
            // 
            // ASYNC PICA INIT 
            //
                var me;
                me = this; 

                var files; //FileList (ref to file on disk)
                e.preventDefault();
                e.target.classList.remove('hover');
                files = e.target.files || e.dataTransfer.files;
                this.FileList = files;
                if (!files.length) {
                    return;
                }        
                
                for (let i = 0; i < files.length; i++) {
                    // the FileList is immutable, need to create a copy (as array)
                    // that can be updated (will act as queue)
                    this.workingFileList.push(i)
                }

                // Check Total Upload Size and Length
                this.totalLength = files.length + this.globalImages.uploadedImages.length
                for (let i = 0; i < this.FileList.length; i++) { 
                    this.totalUploadSize = this.totalUploadSize + this.FileList[i].size
                };
                this.totalUploadSize = (this.totalUploadSize/1000000).toFixed(2)
                if (this.totalUploadSize > this.totalSizeBeforeCompression) {
                    // open modal to receive resize input from user
                    
                    UIkit.modal('#modal-resize-select', {bgClose:false, bgEsc:false}).show();

                } else {
                    me.startProgress(this.totalLength)
                    return me.asyncImageLoadStarter(); 
                }
                
                // Check if there is a Favorite watermark (these are applied automatically) << this is overkill.. I could do it when firebase returns marks
                // this would need to run _after_ call to firebase
                for (let i = 0; i < me.globalMarks.savedMarks.length; i++) {
                    if (me.globalMarks.savedMarks[i].favorite == true) {
                        Vue.set(me.globalSessionInfo, 'hasFavorite', true) 
                        Vue.set(me.globalSessionInfo, 'favoriteIndex', i) 
                    }      
                }          

            },
            userAcceptedResize() {
                this.compressOnImport = true;
                Vue.set(this.globalSessionInfo, 'compressOnImport', true) 
                if (this.globalSessionInfo.hasFavorite) {
                    Vue.set(this.globalSessionInfo, 'appliedWatermark', true) 
                    Vue.set(this.globalSessionInfo, 'appliedWatermarkIndex', this.globalSessionInfo.favoriteIndex) // this highlights selected watermark without triggering selectedId watcher  
                }              
                UIkit.modal('#modal-resize-select').hide().then(function () {UIkit.modal('#modal-resize-select').$destroy(true)});
                this.startProgress(this.totalLength)
                this.asyncImageLoadStarter();            
                // OMGSCOTT add firebase call to say user tried to upload a shit ton of photos     
            },
            userRejectedResize() {
                // some of the init work is done above (to simplify normal imports).. if user rejects resize, undo initial setup
                UIkit.modal('#modal-resize-select').hide().then(function () {UIkit.modal('#modal-resize-select').$destroy(true)}); // only works sometimes because vue keeps stealing the DOM
                this.totalUploadSize = 0;
                this.totalLength = 0;
                this.workingFileList = [];
                Vue.set(this.globalSessionInfo, 'compressOnImport', null) 
                Vue.set(this.globalSessionInfo, 'appliedWatermark', false) 
                Vue.set(this.globalSessionInfo, 'appliedWatermarkIndex', null)                
            },
            asyncImageLoadStarter: function() {
                // 
                // ~~    ASYNC PICA IMPORT    ~~
                //   
                
                /* this section adds a blank json element into the globalImages.uploadedImages array which is the first step of import
                it then kicks off asyncImageProcessing                
                */

                var me;
                me = this; // ref vue instance from inside functions that declare their own scope

                // pick first image in working list to process
                // the "async pica import" will be one at a time, sequentially starting at pos 0
                let idx = this.workingFileList[0]
                this.workingFileList.splice(0, 1);
                var file = this.FileList[idx]; // needs to be original file list for security reasons, this could also be files[idx] (would need to add as param of asyncImageLoadStarter: function(files))                                  

                // NEED TO ADD IMG EXT CHECK !!! OMG OMG OMG OMG OMG OMG WOW OMG SCOTT OMG
                    // OMGSCOTT
                // 

                // Create placeholder for image being uploaded
                me.globalImages.uploadedImages.push({
                    fileName: file.name, // also avaialble in fileRef object
                    fileRef: file, // file from HTML FileList
                    dataURL: '', // full size image
                    thumbnailURL: '',
                    watermark: '',                    
                    exif: {},
                    properties: {
                        height: '', 
                        width: '',
                        scaledHeight: '',
                        scaledWidth: '',
                        aspectRatio: '', // make this computed?
                        isScaled: false, // is image scaled
                    }
                })      
                

                /* TRYING OBJECTURL AFTER THIS COMMENTED OUT DATAURL SECTION
                // Actual Import Takes place here
                var reader = new FileReader();
                
                reader.onload = function(e) {
                    // When image is ready in browser, decide to compress or import original. The logic for "original" is pretty redundant and can
                    // likely be cleaned up because there is a bit of overlap between compress import and original import 
                    // e.target.result is a dataURL
                    me.asyncImageProcessing(e.target.result, idx)
                }
                
                // you could import reader.readAsArrayBuffer(file); here, but zip and most all image processing
                // requires that the image is stored as a dataURL. However, Jimp requires an ArrayBuffer which
                // can be easily created by taking the base64 string in the dataURL and encoding it
                reader.readAsDataURL(file);   
                */
                window.URL = window.URL || window.webkitURL;
                let imgURL = window.URL.createObjectURL(file)
                me.asyncImageProcessing(imgURL, idx)

            },
            asyncImageProcessing: function(imgURL, idx) {
                var me;
                me = this; // ref vue instance from inside functions that declare their own scope
                
                const totalNumPhotos = this.globalImages.uploadedImages.length - 1; // always last object in array, its reactive so its always the "next" avail increment

                // ** KEEPING EXIF separate for now because it doesn't easily work with ObjectURL ... you need to create a src image or imgBuff to process which seems redundant and slow
                // e.target.result is dataURL which has some meta junk in the beginning before the base64 string
                // this needs to be removed and an array buffer needs to be used both for jimp + exif extract
                // every other image ref should be in base64 becuase its easier and more standard to deal with
                // let imgBuff = base64_arraybuffer.decode(fileDaimgURLta.replace(/^data:image\/[a-z]+;base64,/, ""))          
                // save exif (btw this is kinda slow... like 7% of processing time probably)
                // Vue.set(me.globalImages.uploadedImages[totalNumPhotos], 'exif', EXIF.readFromBinaryFile(imgBuff))
                
                if (me.globalSessionInfo.compressOnImport) {                                                                                            
                    resizeImage(imgURL, me.maxXY, me.imageQuality)
                    .then(result => {
                        // result[0] = resizedImgURL (url), result[1] = imgDims (object)
                        
                        // update thumbnailURL with resized image (returned by module function)
                        Vue.set(me.globalImages.uploadedImages[totalNumPhotos], 'thumbnailURL', result[0])   
                        // take new image dimensions and update globalImages
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'height', result[1].oldHeight)
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'width', result[1].oldWidth)
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'scaledHeight', result[1].newHeight)
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'scaledWidth', result[1].newWidth)  
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'aspectRatio', result[1].aspectRatio)   
                        // mark that image has been scaled
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'isScaled', true)

                        // kick of next import
                        if (me.workingFileList.length > 0) {
                            me.asyncImageLoadStarter();
                        } else {
                            // finish progress bar
                            me.finishProgress();
                        } 
                    })                                
                } else {
                    //
                    // Import raw image files, no resize
                    //

                    const srcImage = new Image()
                    srcImage.src = imgURL
                    srcImage.onload = function() {
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'height', srcImage.height)
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'width', srcImage.width)
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'scaledHeight', srcImage.height)
                        Vue.set(me.globalImages.uploadedImages[idx].properties, 'scaledWidth', srcImage.width)       
                        Vue.set(me.globalImages.uploadedImages[totalNumPhotos], 'thumbnailURL', imgURL)
                    }                    

                    // kick of next import
                    if (me.workingFileList.length > 0) {
                        me.asyncImageLoadStarter();
                    } else {
                        // Finish progress bar
                        me.finishProgress();

                        // Apply Favorite
                        /*
                        if (me.globalSessionInfo.hasFavorite) {
                            setTimeout(function(){ 
                                me.$parent.applyWatermark(me.globalSessionInfo.favoriteIndex)
                            }, 800);
                        }
                        */                
                    }
                }        
            },

            FileDragHover: function(e) {
                e.stopPropagation();
                e.preventDefault();
                return e.target.className = e.type === 'dragover' ? 'hover' : '';
            },
            startProgress (totalLength) {
                
                let el = document.getElementById("modal-center");
                if (el) {
                    UIkit.modal('#modal-center').hide().then(function () {UIkit.modal('#modal-center').$destroy(true)});
                }
                
                this.$Progress.start()
                
                this.$notify({
                    title: 'Importing',
                    group: 'loading',
                    duration: 100000,
                    data: {length: totalLength}
                });
            },
            setProgress (num) {
                this.$Progress.set(num)
            },
            increaseProgress (num) {
                this.$Progress.increase(num)
            },
            decreaseProgress (num) {
                this.$Progress.decrease(num)
            },
            finishProgress () {
                this.$Progress.finish()
                UIkit.notification.closeAll()
                
                // notify clean: true gets rid of all notifications, then success shows completed
                this.$notify({
                    group: 'loading',
                    type: 'info',
                    clean: true,
                });

                this.$notify({
                    title: 'Complete!  <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>',
                    text: 'Imported ' + this.globalImages.uploadedImages.length + ' photos',
                    group: 'loaded',
                    type: 'success',
                    duration: 1000
                });          

            },
            failProgress () {
                this.$Progress.fail()
            }            
        },       
        mounted() {
        },
        ready: function() {
            var filedrag;
            return filedrag = document.getElementById("filedrag");
        }
    }
</script>

<style scoped>
  .uk-placeholder {
    margin-bottom: 25px;
    margin-top: 25px;
    padding: 160px 0 160px 0;
    background: rgb(240, 240, 240);
    border: 1px dashed #b4b4b4;
    border-radius: 5px;
  }

  .uk-dragover {
    background-color: #F5F5F5;
    border: 2px dashed #39f;
    box-shadow: 0 0 20px rgba(124, 124, 124, 0.363);
  }

  .uk-text-middle {
    vertical-align: middle !important;
  }

  #image-upload {
      cursor: pointer !important;
  }

  .container {
      border-style: dotted;
      height: 200px;
      width: 100%;
  }


    .upload input {
        outline: none;
    }
    .upload-input {
        display: none;
    }

    #filedrag {
        margin-bottom: 25px;
        margin-top: 25px;
        padding: 160px 0 160px 0;
        background: rgb(240, 240, 240);
        border: 1px dashed #b4b4b4;
        border-radius: 6px;
        box-shadow: 0 0 0 transparent;
        transition: 0.2s ease;
    }
    #filedrag.hover {
        background-color: #F5F5F5;
        border: 1px dashed #39f;
        box-shadow: 0 0 20px rgba(104, 104, 104, 0.363);
    }

    .uk-modal-footer-edit {
        padding: 10px 0 0 0;
        border-top: none;
    }

    .resize-modal-body {
        margin: auto;
        width: 80%;
    }

    .resize-accordian-title {
        background-color: rgb(240, 240, 240);
        padding: 10px 8px 10px 18px;
    }

    .uk-accordion-content {
        border-bottom: 1px solid rgb(240, 240, 240);
    }

</style>

